import { render, staticRenderFns } from "./QuestionComponent.vue?vue&type=template&id=3c7b6224"
import script from "./QuestionComponent.vue?vue&type=script&lang=js"
export * from "./QuestionComponent.vue?vue&type=script&lang=js"
import style0 from "./QuestionComponent.vue?vue&type=style&index=0&id=3c7b6224&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports